<template>
  <v-card>
    <v-card-title class="subtitle-1 font-weight-bold grey lighten-2">
      <span>Persona que recibe el pedido</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <span v-html="subTitle"></span>
    </v-card-subtitle>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
                v-model="nombreReceptor"
                label="Nombre y Apellido"
                required
                :rules="[rules.required]"
                @keyup="$emit('update:receptor',nombreReceptor)"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <small>Ingrese el nombre de la persona que recibió el pedido</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
          color="black darken-1"
          text
          small
          @click="actions('cancelar')"
      >
        Cancelar
      </v-btn>
      <v-btn
          color="blue darken-1"
          outlined
          text
          :disabled="!nombreReceptor"
          @click="actions('clickEnOK')"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'card-confirm-text',
  props: {
    subTitle: {},
  },
  data: () => ({
    rules: { required: value => !!value || 'Campo requerido.'},
    nombreReceptor: ''
  }),
  methods:{
    actions(action){
      this.$emit(`${action}`, false)

    }
  },
  beforeDestroy() {
    this.nombreReceptor = ''
  }
}
</script>
